import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { MatDialogClose } from '@angular/material/dialog';

@Component({
    selector: 'app-empty-wishlist-dialog',
    imports: [MatIcon, MatDialogClose],
    templateUrl: './empty-wishlist-dialog.component.html',
    styleUrl: './empty-wishlist-dialog.component.scss'
})
export class EmptyWishlistDialogComponent {
  protected readonly ESvgIcons = ESvgIcons;
}
